export const SURVEYS_TYPES_MINIMAL_FIELDS = `
  fragment surveyTypesMinimalFields on survey_types {
    id
    survey_types_translations {
      label
    }
  }
`;
